import { render } from "./ShopByConcern.vue?vue&type=template&id=7848fd4d&scoped=true"
import script from "./ShopByConcern.vue?vue&type=script&lang=js"
export * from "./ShopByConcern.vue?vue&type=script&lang=js"

import "./ShopByConcern.vue?vue&type=style&index=0&id=7848fd4d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7848fd4d"]])

export default __exports__